import React from 'react'
import ProtectedRoute from '../../wrappers/ProtectedRoutes'
import { AdminLayout } from '../../layouts/DashboardLayout'
import { Navigate, Route, Routes } from 'react-router-dom'
import SupportNav from './support/SupportNav'
import AdministrationNav from './administration/AdmnistrationNav'
import DashboardPage from '../../pages/DashboardPage'

export default function ProtectedNav() {
    return (
        <ProtectedRoute allowedRoles={["ADMIN"]}>
            <AdminLayout>
                <Routes>
                    <Route path="/support/dashboard" element={<DashboardPage />} />
                    
                    {/* Routes pour Support */}
                    <Route path="/support/*" element={<SupportNav />} />
                    
                    {/* Routes pour Administration */}
                    <Route path="/admin/*" element={<AdministrationNav />} />
                    
                    {/* Redirection par défaut */}
                    <Route path="*" element={<Navigate to="/support/dashboard" replace />} />
                </Routes>
            </AdminLayout>
        </ProtectedRoute>
    )
}